import React from "react";

export const Loader = () => {
    return (
        <div className="loader">
            <img src={'/img/logo.png'} alt={'logo'}/>
        </div>
    )
}